"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APVerticalScroller.css");
var _excluded = ["children", "styleName", "restPosition", "onScrollRestChange", "customClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var scrollerClasses = (0, _cssClassesHelper.getBEMClasses)('ap-vertical-scroller');
var APVerticalScroller = /*#__PURE__*/function (_React$Component) {
  function APVerticalScroller(props) {
    var _this;
    _classCallCheck(this, APVerticalScroller);
    _this = _callSuper(this, APVerticalScroller, [props]);
    _defineProperty(_this, "resetUserScrolled", function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      _this.userScrolled = false;
      callback();
    });
    _defineProperty(_this, "userScrolled", false);
    _defineProperty(_this, "handleUserScrolled", function () {
      if (_this.state.isAtRest) return _this.userScrolled = false;
      _this.userScrolled = true;
    });
    _this.state = {
      isAtRest: true
    };
    _this.handleOnScroll = _this.handleOnScroll.bind(_this);
    return _this;
  }
  _inherits(APVerticalScroller, _React$Component);
  return _createClass(APVerticalScroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToRest();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var descendantCount = this.getDescendantCount(this, 4);
      if (descendantCount !== this.descendantCount) {
        // handle change
        this.descendantCount = descendantCount;
        if (this.state.isAtRest) {
          this.scrollToRest();
        }
      }
      if (this.state.isAtRest) {
        this.resetUserScrolled();
      }
    }
  }, {
    key: "getDescendantCount",
    value: function getDescendantCount(item, levels) {
      var _this2 = this;
      if (levels <= 0 || !item || !item.props || !item.props.children) return 0;
      var children = item.props.children;
      if (Array.isArray(children)) {
        if (levels > 1) {
          return children.reduce(function (acc, curr) {
            return acc + 1 + _this2.getDescendantCount(curr, levels - 1);
          }, 0);
        } else {
          return children.length;
        }
      } else {
        if (levels > 1) {
          return 1 + this.getDescendantCount(children, levels - 1);
        } else {
          return 1;
        }
      }
    }
  }, {
    key: "handleOnScroll",
    value: function handleOnScroll(event) {
      if (!this.el) {
        return;
      }
      this.handleUserScrolled();
      var clientHeight = this.el.clientHeight;
      var scrollHeight = this.el.scrollHeight;
      var newScroll = event.currentTarget.scrollTop;
      var scrollTop = newScroll;
      var scrollBottom = scrollHeight - clientHeight - newScroll;
      var isAtRestPrev = this.state.isAtRest;
      var isAtRest = this.props.restPosition === 'top' && scrollTop <= 0 || this.props.restPosition === 'bottom' && scrollBottom <= 0;
      this.setState({
        isAtRest: isAtRest
      });
      if (isAtRestPrev !== isAtRest) {
        // call event handlers
        if (this.props.onScrollRestChange) {
          this.props.onScrollRestChange(isAtRest);
        }
      }
    }
  }, {
    key: "getIsAtRest",
    value: function getIsAtRest() {
      return this.state.isAtRest;
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(value, animate) {
      if (this.el) {
        if (animate) {
          this.scrollToAnimate(this.el, value, 200);
        } else {
          this.el.scrollTop = value;
        }
      }
    }
  }, {
    key: "scrollToRest",
    value: function scrollToRest(animate) {
      if (!this.userScrolled || this.state.isAtRest) {
        if (this.props.restPosition !== 'bottom') {
          // default to top
          this.scrollTo(0, animate);
        } else {
          // bottom
          if (this.el) {
            this.scrollTo(this.el.scrollHeight, animate);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        children = _this$props.children,
        styleName = _this$props.styleName,
        restPosition = _this$props.restPosition,
        onScrollRestChange = _this$props.onScrollRestChange,
        customClass = _this$props.customClass,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: function ref(el) {
          return _this3.el = el;
        },
        className: "".concat(scrollerClasses(null, this.state.isAtRest ? 'at-rest' : null), " ").concat(customClass),
        onScroll: this.handleOnScroll
      }, otherProps), children);
    }

    // animation from https://codepen.io/rebosante/pen/eENYBv
  }, {
    key: "scrollToAnimate",
    value: function scrollToAnimate(element, to, duration) {
      var _this4 = this;
      var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
      var _animateScroll = function animateScroll() {
        currentTime += increment;
        var val = _this4.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(_animateScroll, increment);
        }
      };
      _animateScroll();
    }

    //t = current time
    //b = start value
    //c = change in value
    //d = duration
  }, {
    key: "easeInOutQuad",
    value: function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
  }]);
}(_react["default"].Component);
APVerticalScroller.propTypes = {
  restPosition: _propTypes["default"].string,
  onScrollRestChange: _propTypes["default"].func,
  customClass: _propTypes["default"].string
};
var _default = exports["default"] = APVerticalScroller;